export const photoUploaderConstant = {
    error: {
        INVALID_FILE_TYPE: 'One or more selected files is not of supported type and was removed',
        FILE_SIZE_EXCEEDED: 'File Size Exceeded. Max File Size is 25 MB',
        UPLOADED_IMAGE_ALREADY_EXIST: 'Uploaded Image already exist',
    },
    labels: {
        PHOTOS: 'Photo',
        VIDEOS: 'Video',
    },
};

